/**
 * API endpoints para Job Titles y Departments
 * Base URL: /api/customers/
 */

import { GET, POST, PUT, DELETE } from "../config";

// ==================== DEPARTMENTS ====================

/**
 * Listar departamentos
 * @param {object} filters - Filtros (branch, is_active)
 * @returns {Promise} Lista de departamentos
 */
export const listDepartments = async (filters = {}) => {
  let url = "customers/departments/?page_size=100";

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  const response = await GET(url);
  return response.data;
};

/**
 * Obtener un departamento por ID
 * @param {string|number} id - ID del departamento
 * @returns {Promise} Datos del departamento
 */
export const getDepartment = async (id) => {
  const response = await GET(`customers/departments/${id}/`);
  return response.data;
};

/**
 * Crear un departamento
 * @param {object} data - Datos del departamento
 * @returns {Promise} Departamento creado
 */
export const createDepartment = async (data) => {
  const response = await POST("customers/departments/", data);
  return response.data;
};

/**
 * Actualizar un departamento
 * @param {string|number} id - ID del departamento
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Departamento actualizado
 */
export const updateDepartment = async (id, data) => {
  const response = await PUT(`customers/departments/${id}/`, data);
  return response.data;
};

/**
 * Eliminar un departamento
 * @param {string|number} id - ID del departamento
 * @returns {Promise}
 */
export const deleteDepartment = async (id) => {
  const response = await DELETE(`customers/departments/${id}/`);
  return response.data;
};

// ==================== JOB TITLES ====================

/**
 * Listar cargos/puestos de trabajo
 * @param {object} filters - Filtros (branch, department, is_active)
 * @returns {Promise} Lista de cargos
 */
export const listJobTitles = async (filters = {}) => {
  let url = "customers/job-titles/?page_size=100";

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.department) {
    url += `&department=${filters.department}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  const response = await GET(url);
  return response.data;
};

/**
 * Obtener un cargo por ID
 * @param {string|number} id - ID del cargo
 * @returns {Promise} Datos del cargo
 */
export const getJobTitle = async (id) => {
  const response = await GET(`customers/job-titles/${id}/`);
  return response.data;
};

/**
 * Crear un cargo
 * @param {object} data - Datos del cargo
 * @returns {Promise} Cargo creado
 */
export const createJobTitle = async (data) => {
  const response = await POST("customers/job-titles/", data);
  return response.data;
};

/**
 * Actualizar un cargo
 * @param {string|number} id - ID del cargo
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Cargo actualizado
 */
export const updateJobTitle = async (id, data) => {
  const response = await PUT(`customers/job-titles/${id}/`, data);
  return response.data;
};

/**
 * Eliminar un cargo
 * @param {string|number} id - ID del cargo
 * @returns {Promise}
 */
export const deleteJobTitle = async (id) => {
  const response = await DELETE(`customers/job-titles/${id}/`);
  return response.data;
};

// ==================== EXPORT ====================

const jobTitlesApi = {
  // Departments
  listDepartments,
  getDepartment,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  // Job Titles
  listJobTitles,
  getJobTitle,
  createJobTitle,
  updateJobTitle,
  deleteJobTitle,
};

export default jobTitlesApi;
